<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <span>
        <a-icon type="wallet" class="margin-right-small" />
        Account Pay / Addendum Supplier
      </span>
      <a-button @click="handleReload" size="small" icon="reload"></a-button>
    </div>
    <div class="wrapper-body">
      <a-card>
        <div style="display: none">
          <a-select placeholder="Ex: Need Process ... " v-model="tabs.active" :disabled="true" @change="moreSearch"
            class="width-full" initialValue="process" allowClear>
            <a-select-option value="needprocess">Need Process</a-select-option>
            <a-select-option value="queue">Queue</a-select-option>
            <a-select-option value="release">Release</a-select-option>
            <a-select-option value="cancel">Cancel</a-select-option>
          </a-select>
        </div>
        <a-row :gutter="16">
          <a-col :xs="{ span: 24 }" :lg="{ span: 21 }">
            <a-input-search v-model="search" placeholder="Quick Search" />
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 3 }">
            <div style="width:100%;text-align:center">
              <a-button :class="getScreen ? 'margin-top' : ''" :icon="advancedsearch == 'display:none' ? 'down' : 'up'"
                @click="handleshowMore">{{
                  advancedsearch == "display:none" ? "More" : "Less"
                }}</a-button>
              <!-- &nbsp;
            <a-button type="primary" icon="plus" @click="handleCreateGeneralAddendum">
              General Addendum
            </a-button> -->
            </div>
          </a-col>
        </a-row>
        <a-row :style="advancedsearch" :gutter="16" class="margin-top">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <div class="m-form-item-wrapper">
              <label>Transaction Date</label>
              <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="transactionDt"
                :format="getDefaultDateFormat" allowClear />
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <div class="m-form-item-wrapper">
              <label>Transaction Type</label>
              <a-select placeholder="Ex: All Transaction ... " v-model="typetransaction" class="width-full"
                initialValue="all">
                <a-select-option value="all">All transaction</a-select-option>
                <a-select-option value="PO">PO</a-select-option>
                <a-select-option value="WO">WO</a-select-option>
                <a-select-option v-if="tabs.active == 'queue'" value="Adendum">Addendum</a-select-option>
                <!-- <a-select-option value="Adendum">Adendum</a-select-option> -->
              </a-select>
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <div class="m-form-item-wrapper">
              <label>Supplier</label>
              <a-select showSearch v-model="supplier_nm" placeholder="Select Supplier Name" class="width-full"
                initialValue="delivered" allowClear :filterOption="filterOption">
                <a-select-option v-for="item in listSuplier" :key="item" :value="item">{{ item }}</a-select-option>
              </a-select>
            </div>
          </a-col>
          <!-- <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <div
              v-if="tabs.active == 'needprocess'"
              class="m-form-item-wrapper"
            >
              <label>Revised Status</label>
              <a-select
                showSearch
                v-model="revisedStatus"
                placeholder="Select Status"
                class="width-full"
                initialValue="undefined"
                allowClear
                :filterOption="filterOption"
              >
                <a-select-option value="all">All</a-select-option>
                <a-select-option value="Revised">Revisable</a-select-option>
                <a-select-option value="Revised Disabled"
                  >Can't Revise</a-select-option
                >
                <a-select-option value="Revised On Process"
                  >Revise On Process</a-select-option
                >
              </a-select>
            </div>
          </a-col> -->
        </a-row>
      </a-card>
      <div class="bordered">
        <a-tabs class="custom-tabs" :activeKey="tabs.active" @change="handleTab">
          <a-tab-pane v-if="!isAkuntansi" key="needprocess">
            <template slot="tab">
              <span>Need Process</span>&nbsp;
              <a-badge class="m-badge m-badge-small" :count="needProcess.length" :numberStyle="{ backgroundColor: 'red' }"
                v-if="needProcess.length > 0">
              </a-badge>
            </template>
            <a-table :rowKey="(record, index) => {
              return index.toString();
            }
              " size="small" bordered :scroll="{ x: 1300 }" :columns="columns.needProcess" :dataSource="needProcess"
              :loading="tabs.loading">
              <template slot="nomor" slot-scope="text, data, index">
                <span>{{ index + 1 }}</span>
              </template>
              <template slot="value" slot-scope="text, data">
                <div>{{ formatCurrency(data.tipe_invoice=='Adendum' ? 'IDR' : data.mata_uang, data.value) }}</div>
                <small v-if="data.tipe_invoice=='Adendum' && data.currency_label!='IDR'">
                  {{ formatCurrency(data.currency_label, data.value_label) }}
                </small>
              </template>
              <template slot="sisatransfer" slot-scope="text, data">
                <div>{{
                  formatCurrency(
                    data.tipe_invoice=='Adendum' ? 'IDR' : data.mata_uang,
                    data.sisa_trf.replace("e-", "")
                  )
                }}</div>
                <small v-if="data.tipe_invoice=='Adendum' && data.currency_label!='IDR'">
                  {{ formatCurrency(data.currency_label, data.sisa_trf_label) }}
                </small>
              </template>
              <template slot="aksi" slot-scope="text, data">
                <a-button-group>
                  <a-button @click="handleManifestRefNedProcess(data)" icon="file"></a-button>
                  <a-button type="primary" @click="handleCreateApAd(data)"><a-icon type="plus" />&nbsp;Create</a-button>
                  <!-- <a-popover title="Select Action Create" trigger="click" placement="bottomRight" >
                    <ul class="m-list-wrapper" slot="content">
                      <li>
                        <a-button type="dashed" class="m-width-full"
                          @click="handleCreate(data)">Account Pay</a-button>
                      </li>
                      <li>
                        <a-button type="dashed" class="m-width-full"
                          @click="handleCreateAddendum(data)">Addendum</a-button>
                      </li>
                    </ul>
                    <a-button
                      type="primary"
                      ><a-icon type="plus" />&nbsp;Create</a-button
                    >
                  </a-popover> -->
                  <!-- <a-button
                    @click="handleManifestRef(data)"
                    icon="file"
                  ></a-button>
                  <a-button
                    type="primary"
                    @click="handleCreate(data)"
                    :disabled="
                      data.button_aksi === 'Revised On Process' ? true : false
                    "
                    >Create AP</a-button
                  > -->
                  <!-- <a-button
                    :type="
                      data.button_aksi === 'Closed Enabled' ? 'danger' : ''
                    "
                    @click="handleRevisiAndClose(data)"
                    :disabled="data.button_aksi === 'Revised' ? false : true"
                    :style="
                      data.button_aksi === 'Revised On Process'
                        ? 'color:red'
                        : ''
                    "
                    :icon="
                      data.button_aksi === 'Revised On Process'
                        ? 'progress'
                        : 'edit'
                    "
                    >{{
                      data.button_aksi === "Revised On Process"
                        ? "Process"
                        : "Revise " + data.jenis.replace("Addendum", "ADD.")
                    }}</a-button
                  > -->
                </a-button-group>
              </template>
            </a-table>
          </a-tab-pane>
          <a-tab-pane v-if="!isAkuntansi" key="queue">
            <template slot="tab">
              <span>AP/Addendum Queue </span>&nbsp;
              <a-badge class="m-badge m-badge-small" :count="queue.length" :numberStyle="{ backgroundColor: 'red' }"
                v-if="queue.length > 0">
              </a-badge>
            </template>
            <a-table :rowKey="(record, index) => {
              return index.toString();
            }
              " size="small" bordered :scroll="{ x: 1300 }" :columns="columns.queue" :dataSource="queue"
              :loading="tabs.loading">
              <template slot="nomor" slot-scope="text, data, index">
                <span>{{ index + 1 }}</span>
              </template>
              <template slot="createBy" slot-scope="text, data">
                <h4 class="margin-remove">{{ data.tlc_create }}</h4>
                <span>{{
                  moment(data.create_dt).format(getDefaultDateFormat)
                }}</span>
              </template>
              <template slot="duedate" slot-scope="text, data">
                <span>{{
                  moment(data.due_date).format(getDefaultDateFormat)
                }}</span>
              </template>
              <template slot="value" slot-scope="text, data">
                <span>{{ formatCurrency(data.mata_uang, data.value) }}</span>
              </template>
              <template slot="sts" slot-scope="text, data">
                <Status v-if="data.status != null" :status="data.status" />
                <span v-else>-</span>
              </template>
              <template slot="aksi" slot-scope="text, data">
                <a-button-group>
                  <a-button @click="handleManifestQueue(data)" icon="file"></a-button>
                  <a-button type="primary" @click="handleRelease(data)" :disabled="!(data.status == 'Verified' || data.status == null)
                    ">Release</a-button>
                </a-button-group>
              </template>
            </a-table>
          </a-tab-pane>
          <a-tab-pane v-if="!isAkuntansi" key="cancel">
            <template slot="tab">
              <span>Canceled</span>&nbsp;
            </template>
            <a-table :rowKey="(record, index) => {
              return index.toString();
            }
              " size="small" bordered :scroll="{ x: 1300 }" :columns="columns.queue" :dataSource="cancel"
              :loading="tabs.loading">
              <template slot="nomor" slot-scope="text, data, index">
                <span>{{ index + 1 }}</span>
              </template>
              <template slot="createBy" slot-scope="text, data">
                <h4 class="margin-remove">{{ data.tlc_create }}</h4>
                <span>{{
                  moment(data.create_dt).format(getDefaultDateFormat)
                }}</span>
              </template>
              <template slot="duedate" slot-scope="text, data">
                <span>{{
                  moment(data.due_date).format(getDefaultDateFormat)
                }}</span>
              </template>
              <template slot="value" slot-scope="text, data">
                <span>{{ formatCurrency(data.mata_uang, data.value) }}</span>
              </template>
              <template slot="sts" slot-scope="text, data">
                <Status v-if="data.status != null" :status="data.status" />
                <span v-else>-</span>
              </template>
              <template slot="aksi" slot-scope="text, data">
                <a-button-group>
                  <a-button @click="handleManifestQueue(data)" icon="file"></a-button>
                  <a-button type="primary" @click="handleRelease(data)" :disabled="!(data.status == 'Verified' || data.status == null)
                    ">Release</a-button>
                </a-button-group>
              </template>
            </a-table>
          </a-tab-pane>
          <a-tab-pane tab="AP Release" key="release">
            <a-table :rowKey="(record, index) => {
              return index.toString();
            }
              " size="small" bordered :scroll="{ x: 1300 }" :columns="columns.release" :dataSource="release"
              :loading="tabs.loading">
              <template slot="nomor" slot-scope="text, data, index">
                <span>{{ index + 1 }}</span>
              </template>
              <template slot="createBy" slot-scope="text, data">
                <h4 class="margin-remove">{{ data.tlc_create }}</h4>
                <span>{{
                  moment(data.create_dt).format(getDefaultDateFormat)
                }}</span>
              </template>
              <template slot="duedate" slot-scope="text, data">
                <span>{{
                  moment(data.due_date).format(getDefaultDateFormat)
                }}</span>
              </template>
              <template slot="value" slot-scope="text, data">
                <span>{{ formatCurrency(data.mata_uang, data.value) }}</span>
              </template>
              <template slot="aksi" slot-scope="text, data">
                <a-button-group>
                  <a-button @click="handleManifest(data)" icon="file">Manifest</a-button>
                  <a-button :disabled="data.flag == null" @click="handleDocument(data)" icon="eye"
                    type="primary"></a-button>
                </a-button-group>
              </template>
            </a-table>
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>

    <a-modal v-model="modalBuktiTransfer" title="Bukti Transfer" :width="500" centered :maskClosable="false">
      <template slot="footer">
        <a-button @click="handleClose()">Tutup</a-button>
      </template>
      <a-list :dataSource="buktiTransfer">
        <a-list-item class="list-item" slot="renderItem" slot-scope="item">
          <div>
            <h4 class="margin-remove">
              {{
                `${moment(item.tgl_tf).format(getDefaultDateFormat)} | ${item.user_tf
                }`
              }}
            </h4>
            <span>{{ formatCurrency(item.currency, item.value_tf) }}</span>
          </div>
          <a-button @click="handleDownload(item)" size="small">Download</a-button>
        </a-list-item>
      </a-list>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import shortingArray from "@/mixins/MultishortArray";

export default {
  name: "account-pay-index",
  mixins: [CurrencyFormat, HandleRoute, shortingArray],
  data() {
    const columns = {
      release: [
        {
          title: "#",
          key: "nomor",
          scopedSlots: { customRender: "nomor" },
          width: 40,
          align: "center",
        },
        {
          title: "No",
          key: "no",
          dataIndex: "no_trans_ap_ad",
          width: 230,
        },
        {
          title: "Deskripsi",
          key: "deskripsi",
          dataIndex: "catatan",
          width: 250,
        },
        {
          title: "Supplier",
          key: "supplier",
          width: 200,
          dataIndex: "nama_supplier",
        },
        {
          title: "No Invoice",
          key: "no_invoice",
          width: 150,
          dataIndex: "no_invoice",
        },
        {
          title: "Create By",
          key: "create_by",
          scopedSlots: { customRender: "createBy" },
          width: 150,
        },
        {
          title: "Due Date",
          key: "due_date",
          scopedSlots: { customRender: "duedate" },
          width: 150,
        },
        {
          title: "No BKK",
          key: "no_bkk",
          dataIndex: "no_bkk",
          width: 150,
        },
        {
          title: "No BP",
          key: "no_bp",
          dataIndex: "no_bp",
          width: 150,
        },
        {
          title: "Value",
          key: "value",
          scopedSlots: { customRender: "value" },
          width: 150,
          align: "right",
        },
        {
          title: "Bukti Transfer",
          key: "number",
          dataIndex: "number",
          width: 160,
          scopedSlots: { customRender: "aksi" },
          align: "center",
        },
      ],
      queue: [
        {
          title: "#",
          key: "nomor",
          scopedSlots: { customRender: "nomor" },
          width: 40,
          align: "center",
        },
        {
          title: "No",
          key: "no_trans_ap_ad",
          dataIndex: "no_trans_ap_ad",
          width: 250,
        },
        {
          title: "Deskripsi",
          key: "deskripsi",
          dataIndex: "catatan",
          width: 250,
        },
        {
          title: "Supplier",
          key: "supplier",
          width: 200,
          dataIndex: "nama_supplier",
        },
        {
          title: "No Invoice",
          key: "no_invoice",
          width: 150,
          dataIndex: "no_invoice",
        },
        {
          title: "Create By",
          key: "create_by",
          scopedSlots: { customRender: "createBy" },
          width: 150,
        },
        {
          title: "Due Date",
          key: "due_date",
          scopedSlots: { customRender: "duedate" },
          width: 150,
        },
        {
          title: "Value",
          key: "value",
          scopedSlots: { customRender: "value" },
          width: 150,
          align: "right",
        },
        {
          title: "Status",
          key: "sts",
          scopedSlots: { customRender: "sts" },
          width: 120,
          align: "center",
          fixed: "right",
        },
        {
          title: "Release",
          key: "release",
          width: 140,
          scopedSlots: { customRender: "aksi" },
          align: "center",
          fixed: "right",
        },
      ],
      needProcess: [
        {
          title: "#",
          key: "nomor",
          scopedSlots: { customRender: "nomor" },
          width: 40,
          align: "center",
        },
        {
          title: "No",
          key: "no",
          dataIndex: "no_inv_ap_ad",
          width: 250,
        },
        {
          title: "Description",
          key: "deskripsi",
          dataIndex: "deskripsi",
        },
        {
          title: "Supplier",
          key: "nama_supplier",
          dataIndex: "nama_supplier",
        },
        {
          title: "Type Invoice",
          key: "tipe_invoice",
          dataIndex: "tipe_invoice",
          align: "center",
        },
        {
          title: "Value",
          key: "value",
          scopedSlots: { customRender: "value" },
          width: 150,
          align: "right",
        },
        {
          title: "Remaining Transfer",
          key: "sisa_trf",
          scopedSlots: { customRender: "sisatransfer" },
          width: 150,
          align: "right",
        },
        {
          title: "Action",
          fixed: "right",
          scopedSlots: { customRender: "aksi" },
          width: 150,
          align: "center",
        },
      ],
    };
    return {
      columns,
      tabs: {
        active: "needprocess",
        loading: false,
      },
      release: [],
      needProcess: [],
      queue: [],
      cancel: [],
      release_origin: [],
      needProcess_origin: [],
      queue_origin: [],
      cancel_origin: [],
      search: undefined,
      typetransaction: "all",
      transactionDt: [],
      buktiTransfer: [],
      modalBuktiTransfer: false,
      advancedsearch: "display:none",
      needProcessSuplier: [],
      quequeSuplier: [],
      cancelSuplier: [],
      releaseSuplier: [],
      listSuplier: [],
      supplier_nm: undefined,
      revisedStatus: "all",
    };
  },
  mounted() {
    if (this.isAkuntansi) {
      this.tabs.active = "release";
    }
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    isAkuntansi() {
      return (this.$route.name == "Spclaccount-pay-index" 
            && this.$route.path == "/akuntansiKeuangan/account_pay") ||
            (this.$route.name == "Spclaccount-pay-indexFin"
            && this.$route.path == "/financialControl/account-pay")
        ? true
        : false;
    },
    moreSearch: function () {
      let tempData = [];
      if (this.tabs.active == "release") {
        tempData = this.release_origin;
      } else if (this.tabs.active == "queue") {
        tempData = this.queue_origin;
      } else if (this.tabs.active == "cancel") {
        tempData = this.cancel_origin;
      } else {
        tempData = this.needProcess_origin;
      }

      if (tempData.length > 0) {
        if (this.search && this.tabs.active == "release") {
          tempData = tempData.filter(
            (obj) =>
              (obj.no_trans_ap_ad &&
                obj.no_trans_ap_ad
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.no_transaksi &&
                obj.no_transaksi
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.catatan &&
                obj.catatan.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0) ||
              (obj.nama_supplier &&
                obj.nama_supplier
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.no_bkk &&
                obj.no_bkk.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0) ||
              (obj.due_date &&
                this.moment(obj.due_date)
                  .format(this.getDefaultDateFormat)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.value &&
                this.formatCurrency(obj.mata_uang, obj.value)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.tlc_create &&
                obj.tlc_create
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0)
          );
          this.intoList(this.tabs.active, tempData);
        } else if (this.search && this.tabs.active == "queue") {
          tempData = tempData.filter(
            (obj) =>
              (obj.no_invoice &&
                obj.no_invoice
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.no_trans_ap_ad &&
                obj.no_trans_ap_ad
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.catatan &&
                obj.catatan.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0) ||
              (obj.nama_supplier &&
                obj.nama_supplier
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.due_date &&
                this.moment(obj.due_date)
                  .format(this.getDefaultDateFormat)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.value &&
                this.formatCurrency(obj.mata_uang, obj.value)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.tlc_create &&
                obj.tlc_create
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0)
          );
          this.intoList(this.tabs.active, tempData);
        } else if (this.search && this.tabs.active == "cancel") {
          tempData = tempData.filter(
            (obj) =>
              (obj.no_invoice &&
                obj.no_invoice
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.no_trans_ap_ad &&
                obj.no_trans_ap_ad
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.catatan &&
                obj.catatan.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0) ||
              (obj.nama_supplier &&
                obj.nama_supplier
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.due_date &&
                this.moment(obj.due_date)
                  .format(this.getDefaultDateFormat)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.value &&
                this.formatCurrency(obj.mata_uang, obj.value)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.tlc_create &&
                obj.tlc_create
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0)
          );
          this.intoList(this.tabs.active, tempData);
        } else if (this.search && this.tabs.active == "needprocess") {
          tempData = tempData.filter(
            (obj) =>
              (obj.no_inv_ap_ad &&
                obj.no_inv_ap_ad
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.no &&
                obj.no.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.deskripsi &&
                obj.deskripsi
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.nama_supplier &&
                obj.nama_supplier
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.value &&
                this.formatCurrency(obj.mata_uang, obj.value)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.sisa_trf &&
                this.formatCurrency(obj.mata_uang, obj.sisa_trf)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0)
          );
          this.intoList(this.tabs.active, tempData);
        }

        if (this.typetransaction && this.typetransaction !== "all") {
          //console.log("this.typetransaction",this.typetransaction)
          tempData = tempData.filter(
            (obj) =>
              obj.jenis_transaksi && obj.jenis_transaksi == this.typetransaction
          );
        }

        if (this.transactionDt && this.transactionDt.length > 0) {
          //console.log(this.transactionDt[0],this.transactionDt[1])
          let startDt = moment(this.transactionDt[0]).format("YYYY-MM-DD");
          let endDt = moment(this.transactionDt[1]).format("YYYY-MM-DD");
          tempData = tempData.filter(
            (obj) =>
              obj.create_dt &&
              moment(obj.create_dt).format("YYYY-MM-DD") >= startDt &&
              moment(obj.create_dt).format("YYYY-MM-DD") <= endDt
          );
        }

        if (this.supplier_nm != "" && this.supplier_nm != undefined) {
          tempData = tempData.filter(
            (obj) => obj.nama_supplier && obj.nama_supplier == this.supplier_nm
          );
        }

        if (this.tabs.active == "needprocess" && this.revisedStatus) {
          if (this.revisedStatus !== "all") {
            tempData = tempData.filter(
              (obj) => obj.button_aksi && obj.button_aksi == this.revisedStatus
            );
          }
        }
      }
      this.intoList(this.tabs.active, tempData);
      if (
        !this.tabs.active &&
        !this.search &&
        !this.transactionDt &&
        !this.typetransaction
      ) {
        this.intoList(this.tabs.active, tempData);
      }
      return true;
    },
  },
  created() {
    let urlfetch = this.isAkuntansi ? "getSpsclAccountPay" : "getAccountPay";
    this.$store.dispatch(urlfetch, { auth: this.getAuth }).then((res) => {
      if (this.isAkuntansi) {
        this.release = res.data.data;
        this.needProcess = {};
        this.queue = {};
        this.cancel = {};

        this.release_origin = res.data.data;
        this.needProcess_origin = {};
        this.queue_origin = {};
        this.cancel_origin = {};

        this.release.forEach((element) => {
          if (this.needProcessSuplier.indexOf(element.nama_supplier) === -1) {
            this.needProcessSuplier.push(element.nama_supplier);
          }
        });

        this.needProcessSuplier.sort();

        this.listSuplier = this.needProcessSuplier;
      } else {
        this.release = res.data.data_rilis;
        this.needProcess = res.data.data_onprocess;
        this.queue = res.data.data_antrian;
        this.cancel = res.data.data_cancel;

        this.release_origin = res.data.data_rilis;
        this.needProcess_origin = res.data.data_onprocess;
        this.queue_origin = res.data.data_antrian;
        this.cancel_origin = res.data.data_cancel;

        this.needProcess_origin.forEach((element) => {
          if (this.needProcessSuplier.indexOf(element.nama_supplier) === -1) {
            this.needProcessSuplier.push(element.nama_supplier);
          }
        });

        this.needProcessSuplier.sort();

        this.queue_origin.forEach((element) => {
          if (this.quequeSuplier.indexOf(element.nama_supplier) === -1) {
            this.quequeSuplier.push(element.nama_supplier);
          }
        });

        // this.cancel_origin.forEach((element) => {
        //   if (this.quequeSuplier.indexOf(element.nama_supplier) === -1) {
        //     this.quequeSuplier.push(element.nama_supplier);
        //   }
        // });

        this.quequeSuplier.sort();

        this.cancel_origin.forEach((element) => {
          if (this.cancelSuplier.indexOf(element.nama_supplier) === -1) {
            this.cancelSuplier.push(element.nama_supplier);
          }
        });
        this.cancelSuplier.sort();

        this.release_origin.forEach((element) => {
          if (this.releaseSuplier.indexOf(element.nama_supplier) === -1) {
            this.releaseSuplier.push(element.nama_supplier);
          }
        });

        this.releaseSuplier.sort();

        this.listSuplier = this.needProcessSuplier;
      }
    });
  },
  methods: {
    moment,
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    resetSearch() {
      this.search = undefined;
      this.transactionDt = undefined;
      this.typetransaction = "all";
      this.supplier_nm = "";
    },
    intoList(type, value) {
      if (type == "release") {
        this.release = value;
      } else if (type == "queue") {
        this.queue = value;
      } else if (type == "cancel") {
        this.cancel = value;
      } else {
        this.needProcess = value;
      }
    },
    handleReload() {
      this.tabs.loading = true;
      let urlfetch = this.isAkuntansi ? "getSpsclAccountPay" : "getAccountPay";
      this.$store.dispatch(urlfetch, { auth: this.getAuth }).then((res) => {
        if (this.isAkuntansi) {
          this.release = res.data.data;
          this.needProcess = {};
          this.queue = {};
          this.cancel = {};

          this.release_origin = res.data.data;
          this.needProcess_origin = {};
          this.queue_origin = {};
          this.cancel_origin = {};

          this.release.forEach((element) => {
            if (this.needProcessSuplier.indexOf(element.nama_supplier) === -1) {
              this.needProcessSuplier.push(element.nama_supplier);
            }
          });

          this.needProcessSuplier.sort();

          this.listSuplier = this.needProcessSuplier;
          this.tabs.loading = false;
        } else {
          this.release = res.data.data_rilis;
          this.needProcess = res.data.data_onprocess;
          this.queue = res.data.data_antrian;
          this.cancel = res.data.data_cancel;

          this.release_origin = res.data.data_rilis;
          this.needProcess_origin = res.data.data_onprocess;
          this.queue_origin = res.data.data_antrian;
          this.cancel_origin = res.data.data_cancel;

          this.tabs.loading = false;

          this.needProcess_origin.forEach((element) => {
            if (this.needProcessSuplier.indexOf(element.nama_supplier) === -1) {
              this.needProcessSuplier.push(element.nama_supplier);
            }
          });

          this.queue_origin.forEach((element) => {
            if (this.quequeSuplier.indexOf(element.nama_supplier) === -1) {
              this.quequeSuplier.push(element.nama_supplier);
            }
          });

          // this.cancel_origin.forEach((element) => {
          //   if (this.quequeSuplier.indexOf(element.nama_supplier) === -1) {
          //     this.quequeSuplier.push(element.nama_supplier);
          //   }
          // });

          this.cancel_origin.forEach((element) => {
            if (this.cancelSuplier.indexOf(element.nama_supplier) === -1) {
              this.cancelSuplier.push(element.nama_supplier);
            }
          });

          this.release_origin.forEach((element) => {
            if (this.releaseSuplier.indexOf(element.supplier) === -1) {
              this.releaseSuplier.push(element.nama_supplier);
            }
          });

          this.listSuplier = this.needProcessSuplier;
        }
      });
      this.resetSearch();
    },
    handleTab(val) {
      this.tabs.active = val;
      this.resetSearch();
      if (val === "needprocess") {
        this.listSuplier = this.needProcessSuplier;
        this.revisedStatus = "all";
      } else if (val === "queue") {
        this.listSuplier = this.quequeSuplier;
      } else if (val === "cancel") {
        this.listSuplier = this.cancelSuplier;
      } else if (val === "release") {
        this.listSuplier = this.releaseSuplier;
      }
    },
    handleCreate(item) {
      this.$router.push({
        name: "account-pay-create",
        params: { id: item.id, type: item.jenis_id },
      });
    },
    handleCreateAddendum(item) {
      this.$router.push({
        name: "createAddendum",
        params: { id: item.id, jenis_transaksi: item.jenis_transaksi },
      });
    },
    handleCreateApAd(item) {
      if (item.tipe_invoice == "Adendum") {
        this.$router.push({
          name: "createAddendum",
          params: {
            id: item.id_invoice_ap_ad,
            jenis_transaksi: item.jenis_transaksi,
          },
        });
      } else {
        this.$router.push({
          name: "account-pay-create",
          params: { id: item.id_invoice_ap_ad, type: item.jenis_id },
        });
      }
    },
    handleCreateGeneralAddendum() {
      this.$router.push({
        name: "createAddendumGeneral",
      });
    },
    handleRelease(item) {
      this.$store
        .dispatch("releaseQueue", {
          auth: this.getAuth,
          id_ap: item.id_account_pay,
          id: item.id,
          jenis_transaksi: item.jenis_transaksi,
        })
        .then((res) => {
          this.$router.go();
          this.displayMessage("success-release");
        });
    },
    handleManifestRef(item) {
      const data = {
        rest_api:
          item.jenis_transaksi.toLowerCase() == "adendum"
            ? item.jenis_transaksi.toLowerCase()
            : "accountpay",
        id_manifest:
          item.jenis_transaksi.toLowerCase() == "adendum"
            ? item.id
            : item.id_account_pay,
        tlc: this.getAuth.username,
        user_pembuat: item.tlc_create,
      };

      this.handleView(data);
    },
    handleManifestRefNedProcess(item) {
      const data = {
        rest_api: "invoice",
        id_manifest: item.id_invoice_ap_ad,
        tlc: this.getAuth.username,
        user_pembuat: item.pembuat,
      };

      this.handleView(data);
    },
    handleManifest(item) {
      if (item.jenis_transaksi == "Adendum") {
        this.$router.push({
          name: "AddendumManifest",
          params: { id: item.id },
        });
      } else {
        if (this.isAkuntansi) {
          this.$router.push({
            name: this.$route.name=="Spclaccount-pay-indexFin" ? 
              "Spclaccount-pay-manifestFin" : "Spclaccount-pay-manifest",
            params: { id: item.id_account_pay },
          });
        } else {
          this.$router.push({
            name: "account-pay-manifest",
            params: { id: item.id_account_pay },
          });
        }
      }
    },
    handleManifestQueue(item) {
      if (item.jenis_transaksi == "Adendum") {
        this.$router.push({
          name: "AddendumManifest",
          params: { id: item.id },
        });
      } else {
        if (this.isAkuntansi) {
          this.$router.push({
            name: "Spclaccount-pay-manifest",
            params: { id: item.id_account_pay },
          });
        } else {
          this.$router.push({
            name: "account-pay-manifest",
            params: { id: item.id_account_pay },
          });
        }
      }
    },
    handleDocument(item) {
      this.$store
        .dispatch("getBuktiAP", { auth: this.getAuth, id: item.id })
        .then((res) => {
          this.buktiTransfer = res.data.data;
          this.modalBuktiTransfer = true;
        });
    },
    handleDownload(item) {
      window.open(this.$serviceUrl + item.url, "_blank");
    },
    handleClose() {
      this.modalBuktiTransfer = false;
    },
    handleshowMore() {
      if (this.advancedsearch == "display:none") {
        this.advancedsearch = "display:block";
      } else {
        this.advancedsearch = "display:none";
      }
    },

    handleRevisiAndClose(item) {
      const that = this;
      let title = "";
      let messageSukses = "";
      title = "Are you sure to revise this data";
      messageSukses = "Successfully revise data";

      this.$confirm({
        title: title,
        content: "Batal / OK?",
        onOk() {
          let promise = new Promise((resolve, reject) => {
            let data = {
              tlc: that.getAuth.username,
              aksi: item.button_aksi,
              id: item.id,
              jenis_transaksi: item.jenis_transaksi,
            };

            // try {
            //   resolve(data);
            // } catch {
            //   reject("error data");
            // }

            axios({
              method: "post",
              url: that.$serviceUrl + "account_pay/aksi_account_pay",
              data: data,
              auth: {
                username: that.getAuth.username,
                password: that.getAuth.password,
              },
              headers: {
                "Content-Type": "application/json",
                "X-API-KEY": that.getAuth.apikey,
              },
            })
              .then(({ data, status }) => {
                resolve(data);
              })
              .catch((err) => {
                reject(err);
              });
          }).catch(() => console.log("Oops errors!"));
          promise
            .then((value) => {
              that.displayMessageValue("success-other", messageSukses);
              that.handleReload();
            })
            .then((err) => {
              if (err) {
                let responses = Object.assign({}, err.response.data);
                that.displayMessageValue("error-other", responses.message);
              }
            });
          return promise;
        },
        onCancel() { },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid darken(white, 10);

  &-header {
    height: 50px;
    background: darken(white, 2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
    font-size: 1rem;
    font-weight: 500;
    color: @color-secondary;
    border-bottom: 1px dashed darken(white, 10);
    padding: @padding;
  }

  &-body {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.bordered {
  border: 1px solid darken(white, 10);
}

.custom-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.list-item {
  display: flex;
  align-items: flex-start;
}
</style>

<style lang="less">
.custom-tabs {
  .ant {
    &-tabs-bar {
      margin-bottom: 0;
    }

    &-tabs-content {
      flex: 1;
    }
  }
}

.ant-table-thead>tr>th {
  text-align: center;
}
</style>
